import { formatMoney as format } from 'accounting';

/*
Formats value as money, returns "-" if value is invalid
*/
export const formatMoney = (value, isInvalid = false) => {
  if (isInvalid) {
    return '-';
  }

  return format(value);
};
